import { useMemo } from 'react';

export default function useCommandesMetrics(commandes) {
  return useMemo(() => {
    if (!Array.isArray(commandes)) return {
      commandesAujourdhui: 0,
      profitAujourdhui: 0,
      ventesAujourdhui: 0,
      commandesEnAttente: 0,
      commandesExpediees: 0,
      commandesRetournees: 0,
      commandesAnnulees: 0,
      moyenneProfit: 0,
      moyenneROI: 0,
      moyenneMarge: 0,
      totalVentes: 0,
      totalProfit: 0,
      totalFBA: 0,
      totalReferral: 0,
      totalTVA: 0,
      repartitionPays: {},
      evolutionVentes: {},
      evolutionProfit: {}
    };

    const aujourdhui = new Date();
    aujourdhui.setHours(0, 0, 0, 0);

    // Commandes d'aujourd'hui
    const commandesAujourdhui = commandes.filter(cmd => {
      const dateCommande = new Date(cmd.DateCommande);
      dateCommande.setHours(0, 0, 0, 0);
      return dateCommande.getTime() === aujourdhui.getTime();
    });

    // Calculs des totaux
    const totals = commandes.reduce((acc, cmd) => ({
      ventes: acc.ventes + (Number(cmd.PrixDeVente) || 0),
      profit: acc.profit + (Number(cmd.Profit) || 0),
      fba: acc.fba + (Number(cmd.fraisFBA) || 0),
      referral: acc.referral + (Number(cmd.fraisReferral) || 0),
      tva: acc.tva + (Number(cmd.TVA) || 0),
      roi: acc.roi + (Number(cmd.ROI) || 0),
      marge: acc.marge + (Number(cmd.Marge) || 0)
    }), {
      ventes: 0,
      profit: 0,
      fba: 0,
      referral: 0,
      tva: 0,
      roi: 0,
      marge: 0
    });

    // Calculs des moyennes
    const moyenneProfit = commandes.length ? totals.profit / commandes.length : 0;
    const moyenneROI = commandes.length ? totals.roi / commandes.length : 0;
    const moyenneMarge = commandes.length ? totals.marge / commandes.length : 0;

    // Répartition par statut
    const commandesEnAttente = commandes.filter(cmd => cmd.Statut === 'Pending' || cmd.Statut === 'Unshipped').length;
    const commandesExpediees = commandes.filter(cmd => cmd.Statut === 'Shipped' || cmd.Statut === 'PartiallyShipped').length;
    const commandesRetournees = commandes.filter(cmd => cmd.Statut === 'Returned').length;
    const commandesAnnulees = commandes.filter(cmd => cmd.Statut === 'Canceled').length;

    // Répartition par pays
    const repartitionPays = commandes.reduce((acc, cmd) => {
      const pays = cmd.Pays || 'Inconnu';
      acc[pays] = (acc[pays] || 0) + 1;
      return acc;
    }, {});

    // Évolution des ventes et profits par jour
    const evolutionVentes = {};
    const evolutionProfit = {};
    commandes.forEach(cmd => {
      const date = new Date(cmd.DateCommande).toLocaleDateString('fr-FR');
      evolutionVentes[date] = (evolutionVentes[date] || 0) + (Number(cmd.PrixDeVente) || 0);
      evolutionProfit[date] = (evolutionProfit[date] || 0) + (Number(cmd.Profit) || 0);
    });

    return {
      commandesAujourdhui: commandesAujourdhui.length,
      profitAujourdhui: commandesAujourdhui.reduce((sum, cmd) => sum + (Number(cmd.Profit) || 0), 0),
      ventesAujourdhui: commandesAujourdhui.reduce((sum, cmd) => sum + (Number(cmd.PrixDeVente) || 0), 0),
      commandesEnAttente,
      commandesExpediees,
      commandesRetournees,
      commandesAnnulees,
      moyenneProfit,
      moyenneROI,
      moyenneMarge,
      totalVentes: totals.ventes,
      totalProfit: totals.profit,
      totalFBA: totals.fba,
      totalReferral: totals.referral,
      totalTVA: totals.tva,
      repartitionPays,
      evolutionVentes,
      evolutionProfit
    };
  }, [commandes]);
} 